import {
    GET_HAPPINESS_TIPS,
    GET_STATE_LOADING
} from "./types/getters.js";

const getters = {
    [GET_HAPPINESS_TIPS]: state => state.happinessTips,
    [GET_STATE_LOADING]: state => state.loading
};

export default getters;
